export const USER_LOG_IN = 'USER_LOG_IN';
export const USER_LOG_OUT = 'USER_LOG_OUT';
export const USER_UPDATE = 'USER_UPDATE';
export const BFIAPPLY_USER_ADD = 'BFIAPPLY_USER_ADD';

export const userLogIn = (user) => (dispatch) => {
    dispatch({ type: USER_LOG_IN, user });
};

export const userLogOut = (user) => (dispatch) => {
    dispatch({ type: USER_LOG_OUT, user });
};

export const userUpdate = (user, loginDT) => (dispatch) => {
    if (user.ffinuser) {
        const loginObject = {
            value: JSON.stringify(user.ffinuser),
            timestamp: loginDT,
        };
        window.localStorage.setItem('ffinuser', JSON.stringify(loginObject));
    }

    if (user.refreshToken) {
        const loginObject = {
            value: JSON.stringify(user.refreshToken),
            timestamp: loginDT,
        };
        window.localStorage.setItem('bfiRefreshToken', JSON.stringify(loginObject));
    }

    dispatch({
        type: USER_UPDATE,
        user,
    });
};

export const setBfiUserAddModal = (state) => (dispatch) => {
    dispatch({ type: BFIAPPLY_USER_ADD, state });
};

export default {
    USER_LOG_IN,
    USER_LOG_OUT,
    USER_UPDATE,
    BFIAPPLY_USER_ADD,
    userUpdate,
    userLogIn,
    userLogOut,
    setBfiUserAddModal,
};
